(function () {
  var drawer = document.getElementById('MenuDrawer');
  if (!drawer) return;

  function update(el) {
    var parent = el.closest('#MenuDrawer nav, .menu-drawer__submenu');
    if (!parent) return;
    var atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 4;
    parent.classList.toggle('lp-at-bottom', atBottom);
  }

  function init() {
    drawer.querySelectorAll('.v-scrollable').forEach(function (el) {
      if (!el._lpGrad) {
        el._lpGrad = true;
        el.addEventListener('scroll', function () { update(el); }, { passive: true });
      }
      update(el);
    });
  }

  // Re-run when drawer opens/closes (hidden attribute changes)
  new MutationObserver(init).observe(drawer, { attributes: true });

  // Re-run when submenu opens or back button is clicked
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('summary, .menu-drawer__item-back-link')) {
      requestAnimationFrame(init);
    }
  });
})();
